import React, { useCallback, } from 'react';

export interface SvgIconProps {
    height?: number | string,
    width?: number,
    src: string,
    alt?: string,
    className?: string,
}

const SvgIcon = ({
    src,
    alt,
    ...props
 }: SvgIconProps) => {
    const reduceProps = useCallback(
        (componentProps: { [key: string]: unknown }, prop: string) => prop in props
                    ? { ...componentProps, [prop]: props[prop as keyof typeof props], }
                    : { ...componentProps },
        [ props, ]
    );

    const verifiedProps = [ 'height', 'width', 'className', ].reduce(reduceProps, {});

    return (
        <img {...verifiedProps}
             src={src}
             alt={alt}
        />
    );
};

SvgIcon.defaultProps = {
    alt: '',
};

export default SvgIcon;
